import { DotMenu } from '@beunity/design';

DotMenu.defaults = {
  deprecatedAppVersion:
    window.App?.Mobile?.DEPRECATE_APP_VERSION_FOR_DOT_MENU || 100,
  mobileAppVersion: window.App?.Mobile?.APP_VERSION || null,
};
